module.exports = __webpack_public_path__ + "img/03.745db665.jpg";